/**
 * Curricular Gamification System
 * Handles island-based mini-games and reward medals.
 */

const CurricularGamification = {
    // Definición de las misiones por isla (Sincronizado con AdventureMap)
    missions: [
        {
            level: 1,
            island: "Isla del Aprendiz",
            game: "Amigos del 10",
            standard: "Cálculo mental y estrategias de descomposición (Bloque A: Sentido Numérico).",
            description: "Encuentra al amigo que completa el 10. ¡Consigue 3 parejas!",
            medal: "🥈 Medalla de Descomposición",
            icon: "🏝️",
            color: "#FFE5B4"
        },
        {
            level: 2,
            island: "Bosque de los Números",
            game: "¿Quién falta?",
            standard: "Ordenación y comparación de números naturales hasta el 100.",
            description: "Encuentra el número que falta en la serie.",
            medal: "🥇 Medalla de Ordenación",
            icon: "🌳",
            color: "#C8E6C9"
        },
        {
            level: 3,
            island: "Montaña del Razonamiento",
            game: "Carga el Barco",
            standard: "Comprensión del sistema de numeración decimal (unidades y decenas).",
            description: "Agrupa 10 unidades para formar una decena.",
            medal: "💎 Medalla de Posición",
            icon: "⛰️",
            color: "#B0BEC5"
        },
        {
            level: 4,
            island: "Cueva de las Operaciones",
            game: "¿Más o menos?",
            standard: "Estimación razonada de cantidades.",
            description: "Observa rápido: ¿Dónde hay más?",
            medal: "👁️ Medalla de Estimación",
            icon: "🗻",
            color: "#BCAAA4"
        },
        {
            level: 5,
            island: "Lago de la Lógica",
            game: "Repara el Puente",
            standard: "Operaciones básicas con modelos manipulativos o visuales.",
            description: "Resuelve la operación para reparar el puente.",
            medal: "🔥 Medalla de Operaciones",
            icon: "🏞️",
            color: "#81D4FA"
        },
        {
            level: 6,
            island: "Bosque de las Formas",
            game: "Series de Formas",
            standard: "Reconocimiento de patrones y series lógicas.",
            description: "Completa la serie con la forma correcta.",
            medal: "🔶 Medalla de Patrones",
            icon: "🌲",
            color: "#A5D6A7"
        },
        {
            level: 7,
            island: "Pantano de la Comparación",
            game: "Boca del Cocodrilo",
            standard: "Comparación de cantidades (Mayor, Menor, Igual).",
            description: "Elige el signo correcto: <, >, =.",
            medal: "🐊 Medalla de Comparación",
            icon: "🐸",
            color: "#CDDC39"
        },
        {
            level: 8,
            island: "Mercado de Monedas",
            game: "Tienda Exacta",
            standard: "Uso del sistema monetario (céntimos).",
            description: "Paga el precio exacto con tus monedas.",
            medal: "🪙 Medalla del Ahorro",
            icon: "🏪",
            color: "#FFD54F"
        },
        {
            level: 9,
            island: "Torre del Cálculo",
            game: "Pirámide de Sumas",
            standard: "Cálculo mental y propiedades de la suma.",
            description: "Completa la pirámide: el bloque de arriba es la suma de los dos de abajo.",
            medal: "🧱 Medalla de Arquitecto",
            icon: "🏰",
            color: "#FFAB91"
        },
        {
            level: 10,
            island: "Espacio de las Llevadas",
            game: "Despegue de Llevadas",
            standard: "Algoritmo de la suma con llevadas.",
            description: "Realiza la suma y lanza la llevada al espacio.",
            medal: "🚀 Medalla Galáctica",
            icon: "🌌",
            color: "#9575CD"
        }
    ],

    activeIntervals: [],
    activeGameData: {}, /* Store state for replays */

    // [FIX] Robust Audio Handler
    safePlay(type) {
        try {
            if (!window.AudioService) return;
            // Try specific methods first, then generic fallback
            if (type === 'pop') {
                if (typeof AudioService.playPop === 'function') AudioService.playPop();
                else if (typeof AudioService.playSFX === 'function') AudioService.playSFX('pop');
            } else if (type === 'success') {
                if (typeof AudioService.playSuccess === 'function') AudioService.playSuccess();
                else if (typeof AudioService.playSFX === 'function') AudioService.playSFX('success');
            } else {
                if (typeof AudioService.playSFX === 'function') AudioService.playSFX(type);
            }
        } catch (e) {
            console.warn(`SafePlay('${type}') failed:`, e);
        }
    },

    safeSpeak(text) {
        try {
            if (window.AudioService && typeof AudioService.speak === 'function') {
                AudioService.speak(text);
            }
        } catch (e) { console.warn("SafeSpeak failed:", e); }
    },

    init() {
        console.log('🎮 Curricular Gamification System Initialized v2.0');
        // Esperad un poco para asegurar que el DOM y otros servicios estén listos
        setTimeout(() => this.renderRewardTrack(), 1000);

        // Fix potential UI artifact by ensuring track is hidden if empty
        const track = document.getElementById('islandRewardTrack');
        if (track) track.style.display = 'none';

        // Debug Button removed from main UI as requested
        // this.addDebugButton();

        // [FIX] Setup global drag handlers for 'Carga el Barco'
        window.allowDrop = (ev) => ev.preventDefault();
        window.drag = (ev) => ev.dataTransfer.setData("text", "unit");
        window.handleDrop = (ev) => {
            // Legacy handler kept for safety, but playCargaBarco uses specific handlers now
            ev.preventDefault();
        };
    },

    addDebugButton() {
        // Prevent duplicate buttons
        if (document.getElementById('debugUnlockBtn')) return;

        const btn = document.createElement('button');
        btn.id = 'debugUnlockBtn';
        btn.innerHTML = "🔓 DESBLOQUEAR TODO (TEST)";
        btn.style.cssText = "position:fixed; bottom:10px; right:10px; z-index:9999; background:#ef4444; color:white; border:none; padding:8px 12px; border-radius:8px; font-size:12px; opacity:0.8; cursor:pointer; font-weight:bold; box-shadow:0 2px 5px rgba(0,0,0,0.2);";
        btn.onmouseover = () => btn.style.opacity = '1';
        btn.onmouseout = () => btn.style.opacity = '0.8';
        btn.onclick = () => {
            if (confirm('¿Desbloquear todas las islas para pruebas?')) {
                // [FIX] Robust call for DEMO environment
                if (typeof this.debugUnlockAll === 'function') this.debugUnlockAll();
                else if (window.CurricularGamification && typeof window.CurricularGamification.debugUnlockAll === 'function') window.CurricularGamification.debugUnlockAll();
            }
        };
        document.body.appendChild(btn);
    },

    /**
     * Muestra la recompensa de la isla al subir de nivel
     */
    showIslandReward(level) {
        const mission = this.missions.find(m => m.level === level);
        if (!mission) return;

        // Limpiar cualquier modal previo
        this.closeModal();

        const modal = document.createElement('div');
        modal.className = 'island-game-modal active';
        modal.id = 'missionModal';
        modal.innerHTML = `
            <div class="island-game-content" style="position:relative;">
                <!-- [FIX] Close Button -->
                <button onclick="CurricularGamification.closeModal()" 
                    style="position:absolute; top:20px; right:25px; background:none; border:none; font-size:2rem; cursor:pointer; color:#64748b; z-index:100;">
                    ✖
                </button>

                <div class="island-game-header" style="display:flex; align-items:center; gap:20px; border-bottom:2px solid #e2e8f0; padding-bottom:15px; margin-bottom:20px;">
                    <div class="island-icon" style="background:${mission.color || '#f1f5f9'}; border:4px solid white; box-shadow:0 10px 20px rgba(0,0,0,0.1);">
                        ${mission.icon}
                    </div>
                    <div style="text-align:left;">
                        <h2 style="font-size:1.8rem; margin:0; color:#1e293b;">¡NUEVA MISIÓN DESBLOQUEADA!</h2>
                        <h3 style="margin:5px 0 0 0; color:#64748b; font-size:1.2rem; font-weight:normal;">${mission.island}</h3>
                    </div>
                </div>
                <div class="island-game-body" id="gameBody">
                    <div style="background:white; padding:25px; border-radius:16px; border:2px dashed #cbd5e1; margin-bottom:20px;">
                        <h3 style="font-size:1.5rem; color:#3b82f6; margin-top:0;">🎯 Misión: ${mission.game}</h3>
                        <p class="mission-desc" style="font-size:1.2rem; line-height:1.5;">${mission.description}</p>
                    </div>
                    <div class="mission-info-box">
                        <button class="btn-info-small" onclick="CurricularGamification.showStandardInfo(${mission.level})">ℹ️ INFORMACIÓN PARA DOCENTES</button>
                    </div>
                </div>
                <div class="island-game-footer" id="gameFooter" style="display:flex; justify-content:center; gap:20px; margin-top:20px;">
                    <button class="btn btn-primary" style="padding:15px 40px; font-size:1.3rem;" onclick="CurricularGamification.startMiniGame(${mission.level})">🚀 ¡EMPEZAR MISION!</button>
                    <button class="btn btn-secondary" onclick="CurricularGamification.closeModal()">DESPUÉS</button>
                </div>
            </div>
        `;
        document.body.appendChild(modal);
    },

    showStandardInfo(level) {
        const mission = this.missions.find(m => m.level === level);
        if (!mission) return;
        alert(`📚 ESTÁNDAR CURRICULAR (1º Primaria):\n\n${mission.standard}`);
    },

    closeModal() {
        // Limpiar intervalos si se cierra forzosamente
        this.activeIntervals.forEach(clearInterval);
        this.activeIntervals = [];

        const modal = document.getElementById('missionModal');
        if (modal) modal.remove();
    },

    openMiniGameHelp(level) {
        const mission = this.missions.find(m => m.level === level);
        if (!mission) return;

        this.closeModal();

        const modal = document.createElement('div');
        modal.className = 'island-game-modal active';
        modal.id = 'missionModal';
        modal.innerHTML = `
            <div class="island-game-content" style="position:relative;">
                <button onclick="CurricularGamification.closeModal()" 
                    style="position:absolute; top:20px; right:25px; background:none; border:none; font-size:2rem; cursor:pointer; color:#64748b; z-index:100;">
                    ✖
                </button>

                <div class="island-game-header" style="display:flex; align-items:center; gap:20px; border-bottom:2px solid #e2e8f0; padding-bottom:15px; margin-bottom:20px;">
                    <div class="island-icon" style="background:${mission.color || '#f1f5f9'}; border:4px solid white; box-shadow:0 10px 20px rgba(0,0,0,0.1);">
                        ${mission.icon}
                    </div>
                    <div style="text-align:left;">
                        <h2 style="font-size:1.8rem; margin:0; color:#1e293b;">Práctica: ${mission.game}</h2>
                        <h3 style="margin:5px 0 0 0; color:#64748b; font-size:1.2rem; font-weight:normal;">Modo de Ayuda</h3>
                    </div>
                </div>
                <div class="island-game-body" id="gameBody">
                    <!-- Game will be injected here -->
                </div>
                <div class="island-game-footer" id="gameFooter" style="display:none;"></div>
            </div>
        `;
        document.body.appendChild(modal);

        // Start game immediately
        setTimeout(() => this.startMiniGame(level), 100);
    },

    startMiniGame(level) {
        const body = document.getElementById('gameBody');
        const footer = document.getElementById('gameFooter');
        if (!body || !footer) return;

        // Limpiar UI inicial
        body.innerHTML = '';
        footer.style.display = 'none'; // Ocultar botones estándar

        switch (level) {
            case 1: this.playAmigosDel10(body, level); break;
            case 2: this.playVecinos(body, level); break;
            case 3: this.playCargaBarco(body, level); break;
            case 4: this.playEstimacion(body, level); break;
            case 5: this.playPuente(body, level); break;
            case 6: this.playSeries(body, level); break;
            case 7: this.playCocodrilo(body, level); break;
            case 8: this.playTienda(body, level); break;
            case 9: this.playPiramide(body, level); break;
            case 10: this.playLlevadas(body, level); break;
            default:
                body.innerHTML = '<p>Juego no implementado aún.</p>';
                setTimeout(() => this.awardMedal(level), 1000);
        }
    },

    // --- JUEGO 1: AMIGOS DEL 10 ---
    playAmigosDel10(container, level) {
        const target = Math.floor(Math.random() * 8) + 1; // 1-8
        const friend = 10 - target;
        let score = 0;
        const goal = 3;

        container.innerHTML = `
            <div class="mini-game-container" id="gameCanvas">
                <div class="bubble-target">${target}</div>
                <div style="position: absolute; top: 10px; right: 10px; font-weight: bold; color: #3b82f6;">Aciertos: <span id="scoreVal">0</span>/${goal}</div>
                <div style="position: absolute; top: 10px; left: 10px; color: #64748b; font-size: 1.5rem; font-weight:bold;">${target} + ❓ = 10</div>
            </div>
        `;

        const canvas = document.getElementById('gameCanvas');

        const spawner = setInterval(() => {
            if (score >= goal) return;
            const isFriend = Math.random() > 0.6; // 40% chance of friend
            const num = isFriend ? friend : Math.floor(Math.random() * 9) + 1;

            const bubble = document.createElement('div');
            bubble.className = 'game-bubble';
            bubble.textContent = num;
            bubble.style.left = Math.random() * 80 + '%';

            bubble.onclick = (e) => {
                e.stopPropagation();
                bubble.classList.add('popped');
                if (num === friend) {
                    score++;
                    document.getElementById('scoreVal').textContent = score;
                    CurricularGamification.safePlay('pop');
                    if (score >= goal) {
                        clearInterval(spawner);
                        setTimeout(() => this.winGame(level), 1000);
                    }
                } else {
                    if (window.SoundService) SoundService.playError();
                }
            };

            canvas.appendChild(bubble);

            // Cleanup
            setTimeout(() => { if (bubble.parentNode) bubble.remove(); }, 4000);

        }, 1200);

        this.activeIntervals.push(spawner);
    },

    // --- JUEGO 2: VECINOS ---
    playVecinos(container, level) {
        const start = Math.floor(Math.random() * 80) + 10;
        // Modes: 0: middle missing, 1: last missing
        const mode = Math.random() > 0.5 ? 0 : 1;

        let seq = [];
        let missingNum;

        if (mode === 0) { // x, ?, z
            seq = [start, null, start + 2];
            missingNum = start + 1;
        } else { // x, y, ?
            seq = [start, start + 1, null];
            missingNum = start + 2;
        }

        // Generate options: correct + 2 distractors
        let options = [missingNum, missingNum - 5, missingNum + 3];
        if (options[1] === missingNum) options[1] += 1;
        if (options[2] === missingNum) options[2] -= 1;
        options.sort(() => Math.random() - 0.5);

        container.innerHTML = `
            <div class="mini-game-container" style="display:flex; flex-direction:column; justify-content:center;">
                <div class="sequence-container">
                    ${seq.map(n =>
            `<div class="sequence-card ${n === null ? 'missing' : ''}">${n === null ? '?' : n}</div>`
        ).join('')}
                </div>
                <div class="number-options">
                    ${options.map(n => `<button class="option-btn" onclick="CurricularGamification.checkVecino(${n}, ${missingNum}, ${level})">${n}</button>`).join('')}
                </div>
            </div>
            <p style="margin-top:0">Completa la serie</p>
        `;
    },

    checkVecino(selected, correct, level) {
        if (selected === correct) {
            const card = document.querySelector('.sequence-card.missing');
            if (card) {
                card.textContent = correct;
                card.classList.remove('missing');
                card.style.background = '#86efac';
            }
            CurricularGamification.safePlay('success');
            setTimeout(() => this.winGame(level), 1000);
        } else {
            if (window.SoundService) SoundService.playError();
        }
    },

    // --- JUEGO 3: CARGA EL BARCO (RESTORED) ---
    playCargaBarco(container, level) {
        let count = 0;
        const goal = 10;

        container.innerHTML = `
            <div class="mini-game-container" style="background: linear-gradient(180deg, #bae6fd 0%, #3b82f6 100%); flex-direction:column; align-items:center;">
                <h3 style="color:#1e3a8a; margin-bottom:10px;">¡Carga 10 cajas en el barco!</h3>
                <div style="font-size:1.5rem; color:white; font-weight:bold; margin-bottom:20px;">
                    Cargadas: <span id="cargo-count">0</span>/${goal}
                </div>
                
                <!-- SHIP -->
                <div id="ship-target" ondrop="CurricularGamification.dropCargo(event)" ondragover="CurricularGamification.allowDropCargo(event)"
                    style="width:280px; height:120px; background:#854d0e; border-radius: 0 0 50px 50px; border:4px solid #451a03; position:relative; display:flex; flex-wrap:wrap; align-items:flex-end; justify-content:center; padding:10px; gap:5px;">
                    <div style="position:absolute; top:-40px; left:20px; font-size:3rem;">🚢</div>
                    <div style="position:absolute; bottom:10px; width:100%; text-align:center; color:rgba(255,255,255,0.3); font-size:2rem; pointer-events:none;">BARCO</div>
                </div>

                <!-- DOCK (Source of cargo) -->
                <div style="margin-top:40px; width:100%; background:#a8a29e; padding:15px; display:flex; gap:10px; justify-content:center; border-top:4px solid #57534e;">
                    <div class="cargo-box" draggable="true" ondragstart="CurricularGamification.dragCargo(event)" style="cursor:grab; font-size:2rem;">📦</div>
                    <div class="cargo-box" draggable="true" ondragstart="CurricularGamification.dragCargo(event)" style="cursor:grab; font-size:2rem;">📦</div>
                    <div class="cargo-box" draggable="true" ondragstart="CurricularGamification.dragCargo(event)" style="cursor:grab; font-size:2rem;">📦</div>
                    <div class="cargo-box" draggable="true" ondragstart="CurricularGamification.dragCargo(event)" style="cursor:grab; font-size:2rem;">📦</div>
                    <div class="cargo-box" draggable="true" ondragstart="CurricularGamification.dragCargo(event)" style="cursor:grab; font-size:2rem;">📦</div>
                </div>
                
                <p style="color:white; margin-top:10px;">Arrastra las cajas al barco</p>
            </div>
        `;

        // Save state for global handlers
        this.activeGameData = { count: 0, goal, level };
    },

    dragCargo(ev) {
        ev.dataTransfer.setData("text", "cargo");
    },

    allowDropCargo(ev) {
        ev.preventDefault();
    },

    dropCargo(ev) {
        ev.preventDefault();
        const data = ev.dataTransfer.getData("text");
        if (data === "cargo") {
            const state = this.activeGameData;
            // Robustness: ensure state exists
            if (!state || typeof state.count === 'undefined') return;

            if (state.count >= state.goal) return;

            state.count++;
            const countEl = document.getElementById('cargo-count');
            if (countEl) countEl.innerText = state.count;

            // Add visual cargo to ship
            const ship = document.getElementById('ship-target');
            if (ship) {
                const box = document.createElement('div');
                box.innerText = '📦';
                box.style.fontSize = '1.3rem';
                box.className = 'dropped-cargo';
                box.style.animation = "popIn 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)";
                ship.appendChild(box);
            }

            CurricularGamification.safePlay('pop');

            if (state.count >= state.goal) {
                CurricularGamification.safePlay('success');
                setTimeout(() => this.winGame(state.level), 1000);
            }
        }
    },

    cleanupBubbles(container) {
        const bubbles = container.querySelectorAll('.math-bubble');
        bubbles.forEach(b => b.remove());
    },

    // --- JUEGO 4: ESTIMACIÓN (UPDATED FLOW) ---
    playEstimacion(container, level) {
        const countA = Math.floor(Math.random() * 8) + 3;
        const countB = Math.floor(Math.random() * 8) + 3;
        // Ensure diff
        if (countA === countB) return this.playEstimacion(container, level);

        const correctJar = countA > countB ? 'A' : 'B';

        container.innerHTML = `
    <div class="mini-game-container" style="background:#fdf2f8; flex-direction:column; align-items:center; justify-content:center; display:flex; position:relative;">
                <div id="est-intro" style="text-align:center; padding:30px; background:white; border-radius:20px; box-shadow:0 10px 25px rgba(0,0,0,0.1); z-index:10;">
                    <h3 style="color:#db2777; margin-bottom:1rem; font-size:2rem;">¡Ojo de Halcón! 🦅</h3>
                    <p style="font-size:1.4rem; margin-bottom:2rem; color:#475569;">Te mostraré dos frascos <strong>muy rápido</strong>.</p>
                    <button class="btn btn-primary" style="padding:15px 40px; font-size:1.4rem;" onclick="CurricularGamification.startEstimacionRound()">¡ESTOY LISTO! 👀</button>
                </div>

                <div id="est-game" style="display:none; width:100%; height:100%; flex-direction:column; align-items:center; justify-content:center;">
                    <p id="est-instruction" style="font-size:2rem; font-weight:900; color:#db2777; margin-bottom:20px; text-transform:uppercase;">¡MIRA BIEN!</p>
                    <div class="estimation-container" id="jarsContainer">
                        <div class="estimation-jar" id="jarA" onclick="CurricularGamification.checkEstimacion('A', '${correctJar}', ${level})">
                            <div class="jar-content" id="contentA" style="transform: scale(0.8); transform-origin: top center;">
                                ${Array(countA).fill('<div class="marble" style="background:#ef4444; width:25px; height:25px; margin:2px;"></div>').join('')}
                            </div>
                            <div class="jar-label">A</div>
                        </div>
                        <div class="estimation-jar" id="jarB" onclick="CurricularGamification.checkEstimacion('B', '${correctJar}', ${level})">
                            <div class="jar-content" id="contentB" style="transform: scale(0.8); transform-origin: top center;">
                                ${Array(countB).fill('<div class="marble" style="background:#3b82f6; width:25px; height:25px; margin:2px;"></div>').join('')} 
                            </div>
                            <div class="jar-label">B</div>
                        </div>
                    </div>
                </div>
                <div id="est-actions" style="display:none; margin-top:40px;">
                    <button id="btnReplay" class="btn btn-secondary" onclick="CurricularGamification.showJarsAgain()" style="display:none; padding:10px 25px; font-size:1.1rem;">🔄 Ver de nuevo (1)</button>
                </div>
            </div >
    `;

        // Store active game data
        this.activeGameData = { countA, countB, correctJar, level, replays: 1 };
    },

    startEstimacionRound() {
        const intro = document.getElementById('est-intro');
        const game = document.getElementById('est-game');
        if (intro) intro.style.display = 'none';
        if (game) game.style.display = 'flex';
        this.showJarsSequence();
    },

    showJarsSequence() {
        const instruction = document.getElementById('est-instruction');
        const contentA = document.getElementById('contentA');
        const contentB = document.getElementById('contentB');
        const actions = document.getElementById('est-actions');
        const replayBtn = document.getElementById('btnReplay');
        const jars = document.querySelectorAll('.estimation-jar');

        if (!instruction || !contentA || !contentB) return;

        // Reset state
        instruction.textContent = "¡MIRA BIEN!";
        instruction.style.color = "#db2777";
        contentA.style.opacity = '1';
        contentB.style.opacity = '1';
        if (actions) actions.style.display = 'none';
        jars.forEach(j => j.style.pointerEvents = 'none');

        jars.forEach(j => j.style.pointerEvents = 'none');

        // Sound
        CurricularGamification.safePlay('pop');

        // Hide after 2 seconds
        setTimeout(() => {
            if (contentA) contentA.style.opacity = '0';
            if (contentB) contentB.style.opacity = '0';
            if (instruction) instruction.textContent = "¿DÓNDE HABÍA MÁS?";
            jars.forEach(j => j.style.pointerEvents = 'auto');

            if (actions) actions.style.display = 'block';
            if (this.activeGameData.replays > 0) {
                if (replayBtn) {
                    replayBtn.style.display = 'block';
                    replayBtn.textContent = `🔄 Ver de nuevo(${this.activeGameData.replays})`;
                }
            }
        }, 2000);
    },

    showJarsAgain() {
        if (this.activeGameData.replays > 0) {
            this.activeGameData.replays--;
            this.showJarsSequence();
        }
    },

    checkEstimacion(selection, correct, level) {
        // Reveal
        document.querySelectorAll('.jar-content').forEach(c => c.style.opacity = '1');
        const replayBtn = document.getElementById('btnReplay');
        if (replayBtn) replayBtn.style.display = 'none';

        if (selection === correct) {
            document.getElementById('est-instruction').innerHTML = "<span style='color:green'>¡CORRECTO! 🎉</span>";
            CurricularGamification.safePlay('success');
            setTimeout(() => this.winGame(level), 1500);
        } else {
            document.getElementById('est-instruction').innerHTML = "<span style='color:red'>Ups... fíjate bien.</span>";
            if (window.SoundService) SoundService.playError();
        }
    },

    // --- JUEGO 5: PUENTE ---
    playPuente(container, level) {
        const a = Math.floor(Math.random() * 5) + 1;
        const b = Math.floor(Math.random() * 4) + 1;
        const sum = a + b;

        container.innerHTML = `
    <div class="mini-game-container" style="background:#fff7ed; flex-direction:column; align-items:center;">
        <div class="bridge-container" style="display:flex; flex-direction:column; align-items:center; gap:20px;">
            <div class="bridge-plank" style="display:flex; align-items:center; gap:10px; font-size:2rem; font-weight:bold; background:#8B4513; padding:20px 40px; border-radius:10px; color:white; box-shadow:0 10px 0 #5D4037;">
                <span>${a}</span>
                <span>+</span>
                <span>${b}</span>
                <span>=</span>
                <input type="number" class="bridge-input" id="bridgeAns"
                    style="width:80px; height:60px; font-size:2rem; text-align:center; border:none; border-radius:8px; color:#333;"
                    onkeyup="if(event.key === 'Enter') CurricularGamification.checkPuente(this.value, ${sum}, ${level})">
            </div>
            <button class="btn btn-primary" onclick="CurricularGamification.checkPuente(document.getElementById('bridgeAns').value, ${sum}, ${level})">
                🔨 REPARAR
            </button>
            <div style="font-size:5rem; margin-top:20px;">🌉</div>
        </div>
                </div>
            </div>
    <p>Repara el puente resolviendo la suma</p>
`;
        setTimeout(() => {
            const input = document.getElementById('bridgeAns');
            if (input) input.focus();
        }, 500);
    },

    checkPuente(val, correct, level) {
        if (!val) return;
        if (parseInt(val) === correct) {
            CurricularGamification.safePlay('success');
            // Visual feedback on the plank
            const plank = document.querySelector('.bridge-plank');
            if (plank) {
                plank.style.background = "#059669"; // Success green
                plank.style.boxShadow = "0 12px 0 #047857";
            }
            setTimeout(() => this.winGame(level), 1000);
        } else {
            if (window.SoundService) SoundService.playError();
            const input = document.getElementById('bridgeAns');
            if (input) {
                input.value = '';
                input.classList.add('error-shake');
                setTimeout(() => input.classList.remove('error-shake'), 500);
                input.focus();
            }
        }
    },

    // --- COMMON ---
    // --- JUEGO 6: SERIES DE FORMAS ---
    playSeries(container, level) {
        // Shapes: 0:Circle, 1:Square, 2:Triangle, 3:Star
        const shapes = ['🔴', '🟦', '🔺', '⭐'];
        const patternType = Math.floor(Math.random() * 2); // 0: ABAB, 1: AABAAB

        let seq = [];
        let missingIndex = 4; // Element to guess
        let pattern = [];
        let answer = '';

        if (patternType === 0) { // ABAB
            const a = shapes[Math.floor(Math.random() * 4)];
            let b = shapes[Math.floor(Math.random() * 4)];
            while (a === b) b = shapes[Math.floor(Math.random() * 4)];
            pattern = [a, b, a, b, a]; // missing 6th
            answer = b;
            seq = [...pattern];
        } else { // ABC... or AAB
            const a = shapes[Math.floor(Math.random() * 4)];
            let b = shapes[Math.floor(Math.random() * 4)];
            while (a === b) b = shapes[Math.floor(Math.random() * 4)];
            pattern = [a, a, b, a, a];
            answer = b;
            seq = [...pattern];
        }

        container.innerHTML = `
    <div class="mini-game-container" style="background:#f0fdf4; flex-direction:column; align-items:center;">
            <h3 style="color:#15803d;">Completa la serie</h3>
            <div style="display:flex; gap:10px; font-size:3rem; margin:20px 0; background:white; padding:20px; border-radius:15px; box-shadow:0 4px 10px rgba(0,0,0,0.1);">
                ${seq.map(s => `<div>${s}</div>`).join('')}
                <div style="border:2px dashed #ccc; width:50px; height:50px; display:flex; align-items:center; justify-content:center;">?</div>
            </div>
            <div style="display:flex; gap:20px; margin-top:20px;">
                ${shapes.map(s => `<button class="btn" style="font-size:2.5rem; padding:10px; background:white; border:2px solid #ddd; cursor:pointer;" onclick="CurricularGamification.checkSeries('${s}', '${answer}', ${level})">${s}</button>`).join('')}
            </div>
        </div >
        `;
    },

    checkSeries(selected, correct, level) {
        if (selected === correct) {
            CurricularGamification.safePlay('success');
            setTimeout(() => this.winGame(level), 500);
        } else {
            if (window.SoundService) SoundService.playError();
        }
    },

    // --- JUEGO 7: BOCA DEL COCODRILO ---
    playCocodrilo(container, level) {
        const n1 = Math.floor(Math.random() * 90) + 10;
        let n2 = Math.floor(Math.random() * 90) + 10;
        // Make equal likely
        if (Math.random() > 0.8) n2 = n1;

        let correctSign = '=';
        if (n1 > n2) correctSign = '>';
        if (n1 < n2) correctSign = '<';

        container.innerHTML = `
    <div class="mini-game-container" style="background:#f7fee7; flex-direction:column; align-items:center;">
                <h3 style="color:#65a30d;">¿Cuál es mayor?</h3>
                <div style="display:flex; align-items:center; gap:30px; font-size:3rem; font-weight:bold; color:#3f6212;">
                    <div style="background:white; padding:20px; border-radius:10px;">${n1}</div>
                    <div id="sign-box" style="width:60px; height:60px; background:#e5e7eb; display:flex; align-items:center; justify-content:center; border-radius:10px;">?</div>
                    <div style="background:white; padding:20px; border-radius:10px;">${n2}</div>
                </div>
                <div style="display:flex; gap:20px; margin-top:30px;">
                    <button class="btn" style="font-size:2rem; padding:10px 30px; background:#84cc16; color:white; border:none; border-radius:8px; cursor:pointer;" onclick="CurricularGamification.checkCocodrilo('<', '${correctSign}', ${level})">&lt;</button>
                    <button class="btn" style="font-size:2rem; padding:10px 30px; background:#65a30d; color:white; border:none; border-radius:8px; cursor:pointer;" onclick="CurricularGamification.checkCocodrilo('=', '${correctSign}', ${level})">=</button>
                    <button class="btn" style="font-size:2rem; padding:10px 30px; background:#4d7c0f; color:white; border:none; border-radius:8px; cursor:pointer;" onclick="CurricularGamification.checkCocodrilo('>', '${correctSign}', ${level})">&gt;</button>
                </div>
                <div style="font-size:4rem; margin-top:20px;">🐊</div>
            </div >
    `;
    },

    checkCocodrilo(selected, correct, level) {
        const box = document.getElementById('sign-box');
        if (selected === correct) {
            box.innerText = selected;
            box.style.background = "#86efac";
            CurricularGamification.safePlay('success');
            setTimeout(() => this.winGame(level), 800);
        } else {
            if (window.SoundService) SoundService.playError();
            box.style.background = "#fca5a5";
            setTimeout(() => box.style.background = "#e5e7eb", 500);
        }
    },

    // --- JUEGO 8: TIENDA EXACTA ---
    playTienda(container, level) {
        const price = Math.floor(Math.random() * 15) + 5; // 5 to 20 cents

        container.innerHTML = `
    <div class="mini-game-container" style="background:#fffbeb; flex-direction:column; align-items:center;">
                <div style="background:white; padding:15px; border-radius:10px; border:3px solid #f59e0b; margin-bottom:20px; text-align:center;">
                    <span style="font-size:3rem;">🧸</span>
                    <h3 style="margin:0; color:#b45309;">Tienda de Céntimos</h3>
                    <p style="margin:0; font-size:0.9rem; color:#78350f;">(Precios simbólicos para aprender)</p>
                    <div style="font-size:2rem; font-weight:bold; color:#d97706; margin-top:5px;">${price} céntimos</div>
                </div>
                
                <div id="wallet" style="display:flex; gap:10px; margin-bottom:20px;">
                   <button onclick="CurricularGamification.addCoin(1)" style="width:50px; height:50px; border-radius:50%; background:#b45309; color:white; border:2px solid #78350f; cursor:pointer; font-weight:bold;">1</button>
                   <button onclick="CurricularGamification.addCoin(2)" style="width:55px; height:55px; border-radius:50%; background:#b45309; color:white; border:2px solid #78350f; cursor:pointer; font-weight:bold;">2</button>
                   <button onclick="CurricularGamification.addCoin(5)" style="width:60px; height:60px; border-radius:50%; background:#fcd34d; color:#92400e; border:2px solid #b45309; cursor:pointer; font-weight:bold;">5</button>
                   <button onclick="CurricularGamification.addCoin(10)" style="width:65px; height:65px; border-radius:50%; background:#fcd34d; color:#92400e; border:2px solid #b45309; cursor:pointer; font-weight:bold;">10</button>
                </div>

                <div style="font-size:1.5rem; font-weight:bold; color:#78350f;">Pagado: <span id="current-pay">0</span> cts</div>
                <div id="coins-paid" style="display:flex; flex-wrap:wrap; gap:5px; height:60px; align-items:center; justify-content:center; max-width:300px;"></div>
                
                <div style="display:flex; gap:10px; margin-top:20px;">
                    <button class="btn" style="background:#ef4444; color:white; padding:5px 15px; border-radius:5px; cursor:pointer;" onclick="CurricularGamification.resetCoins()">Borrar</button>
                    <button class="btn" style="background:#10b981; color:white; padding:10px 30px; border-radius:8px; font-size:1.5rem; cursor:pointer;" onclick="CurricularGamification.checkTienda(${price}, ${level})">PAGAR</button>
                </div>
            </div >
    `;
        this.activeGameData.currentPay = 0;
    },

    addCoin(val) {
        const payEl = document.getElementById('current-pay');
        const container = document.getElementById('coins-paid');
        if (!payEl) return;

        this.activeGameData.currentPay = (this.activeGameData.currentPay || 0) + val;
        payEl.innerText = this.activeGameData.currentPay;

        const coin = document.createElement('div');
        coin.style.cssText = `width: 30px; height: 30px; border-radius: 50%; background:${val >= 5 ? '#fcd34d' : '#b45309'}; border: 1px solid #78350f; display: flex; align-items: center; justify-content: center; font-size: 0.8rem; color:${val >= 5 ? 'black' : 'white'}`;
        coin.innerText = val;
        container.appendChild(coin);
        CurricularGamification.safePlay('pop');
    },

    resetCoins() {
        this.activeGameData.currentPay = 0;
        document.getElementById('current-pay').innerText = "0";
        document.getElementById('coins-paid').innerHTML = "";
    },

    checkTienda(target, level) {
        if (this.activeGameData.currentPay === target) {
            CurricularGamification.safePlay('success');
            setTimeout(() => this.winGame(level), 500);
        } else {
            if (window.SoundService) SoundService.playError();
            const payEl = document.getElementById('current-pay');
            payEl.style.color = "red";
            setTimeout(() => payEl.style.color = "#78350f", 500);
            this.resetCoins();
        }
    },

    // --- JUEGO 9: PIRÁMIDE DE SUMAS ---
    playPiramide(container, level) {
        const base1 = Math.floor(Math.random() * 5) + 1;
        const base2 = Math.floor(Math.random() * 5) + 1;
        const top = base1 + base2;

        container.innerHTML = `
    < div class="mini-game-container" style = "background:#fff1f2; flex-direction:column; align-items:center;" >
                <h3 style="color:#be123c;">Construye la Pirámide</h3>
                <div style="display:flex; flex-direction:column; align-items:center; gap:5px;">
                    <!-- Top Brick -->
                    <div style="width:80px; height:50px; background:#e11d48; color:white; display:flex; align-items:center; justify-content:center; font-size:1.5rem; font-weight:bold; border:2px solid #881337;">?</div>
                    <!-- Bottom Bricks -->
                    <div style="display:flex; gap:5px;">
                        <div style="width:80px; height:50px; background:#fb7185; color:white; display:flex; align-items:center; justify-content:center; font-size:1.5rem; font-weight:bold; border:2px solid #9f1239;">${base1}</div>
                        <div style="width:80px; height:50px; background:#fb7185; color:white; display:flex; align-items:center; justify-content:center; font-size:1.5rem; font-weight:bold; border:2px solid #9f1239;">${base2}</div>
                    </div>
                </div>
                
                <p>¿Qué número va arriba?</p>
                <div style="display:grid; grid-template-columns: repeat(3, 1fr); gap:10px; margin-top:20px;">
                    ${this.shuffleOptions(top, 3).map(opt =>
            `<button class="btn" style="background:white; border:2px solid #e11d48; padding:10px 20px; font-size:1.5rem; cursor:pointer;" onclick="CurricularGamification.checkPiramide(${opt}, ${top}, ${level})">${opt}</button>`
        ).join('')}
                </div>
            </div >
    `;
    },

    // Helper to shuffle correct answer with distractors
    shuffleOptions(correct, count) {
        let opts = [correct];
        while (opts.length < count) {
            let r = correct + Math.floor(Math.random() * 10) - 5;
            if (r > 0 && !opts.includes(r)) opts.push(r);
        }
        return opts.sort(() => Math.random() - 0.5);
    },

    checkPiramide(selected, correct, level) {
        if (selected === correct) {
            CurricularGamification.safePlay('success');
            setTimeout(() => this.winGame(level), 500);
        } else {
            if (window.SoundService) SoundService.playError();
        }
    },

    // --- UI HELPERS ---
    updateGhostInput(val) {
        const ghost = document.getElementById('ans-u-ghost');
        if (!ghost) return;
        if (!val) { ghost.innerHTML = ''; return; }

        const chars = val.toString().split('');
        let html = '';

        // Heuristic: If 2 digits, first is Ten (Red), second is Unit (Blue)
        // If 1 digit, assume it's the Unit (Blue) - or just typed
        if (chars.length === 1) {
            html = `< span style = "color:#2563eb" > ${chars[0]}</span > `;
        } else if (chars.length >= 2) {
            // Take last two
            const ten = chars[chars.length - 2];
            const unit = chars[chars.length - 1];
            html = `< span style = "color:#dc2626" > ${ten}</span > <span style="color:#2563eb">${unit}</span>`;
        }
        ghost.innerHTML = html;
    },

    // --- JUEGO 10: DESPEGUE DE LLEVADAS ---
    playLlevadas(container, level) {
        // Simple 2-digit sum with carry
        const u1 = Math.floor(Math.random() * 4) + 5; // 5-9
        const u2 = Math.floor(Math.random() * 4) + 5; // 5-9
        const d1 = Math.floor(Math.random() * 3) + 1; // 1-3
        const d2 = Math.floor(Math.random() * 3) + 1; // 1-3

        const totalU = u1 + u2;
        const totalD = d1 + d2 + 1; // +1 carry

        this.activeGameData = { phase: 0, totalU, totalD };

        container.innerHTML = `
    < div class="mini-game-container" style = "background:#f3e8ff; flex-direction:column; align-items:center; padding:20px;" >
                <h3 style="color:#7e22ce; margin-bottom:20px;">¡Despegue con Llevada! 🚀</h3>
                
                <div style="display:flex; gap:40px; align-items:flex-start; background:white; padding:30px; border-radius:20px; box-shadow:0 10px 30px rgba(0,0,0,0.15);">
                    <!-- LEFT: OPERATION PANEL -->
                    <div style="display:flex; gap:15px; font-size:3rem; font-family:'Baloo 2', cursive; border-right:2px solid #e5e7eb; padding-right:30px;">
                        <!-- TENS COLUMN (RED) -->
                        <div style="display:flex; flex-direction:column; align-items:center; width:60px;">
                            <span style="font-size:0.9rem; color:#dc2626; font-family:'Baloo 2', cursive; margin-bottom:5px;">DECENAS</span>
                            <div id="carry-slot" style="width:40px; height:40px; border:2px dashed #fca5a5; border-radius:50%; margin-bottom:10px; display:flex; align-items:center; justify-content:center; font-size:1.5rem; color:#dc2626; transition: all 0.5s;"></div>
                            <div style="color:#dc2626;">${d1}</div>
                            <div style="color:#dc2626;">${d2}</div>
                            <div style="border-top:4px solid black; width:100%; margin:10px 0;"></div>
                            <input id="ans-d" type="number" style="width:80px; font-size:2.5rem; text-align:center; border:2px solid #e5e7eb; border-radius:8px; color:#dc2626; font-weight:bold;" disabled>
                        </div>
                        
                        <!-- UNITS COLUMN (BLUE) -->
                        <div style="display:flex; flex-direction:column; align-items:center; width:80px;">
                            <span style="font-size:0.9rem; color:#2563eb; font-family:'Baloo 2', cursive; margin-bottom:5px;">UNIDADES</span>
                            <div style="height:50px;"></div> <!-- Spacer matching carry slot -->
                            <div style="color:#2563eb;">${u1}</div>
                            <div style="color:#2563eb;">${u2}</div>
                            <div style="border-top:4px solid black; width:100%; margin:10px 0;"></div>
                            
                            <!-- GHOST INPUT WRAPPER -->
                            <div style="position:relative; width:80px; height:60px;">
                                <!-- Ghost Display (Visible colors) -->
                                <div id="ans-u-ghost" style="position:absolute; top:0; left:0; width:100%; height:100%; display:flex; align-items:center; justify-content:center; font-size:2.5rem; font-family:'Baloo 2', cursive; font-weight:bold; pointer-events:none; z-index:5;"></div>
                                
                                <!-- Transparent Input (Interaction) -->
                                <input id="ans-u" type="number" style="width:100%; height:100%; position:absolute; top:0; left:0; font-size:2.5rem; text-align:center; background:transparent; border:2px solid #2563eb; border-radius:8px; color:transparent; caret-color:black; z-index:10; font-weight:bold;" 
                                    oninput="CurricularGamification.updateGhostInput(this.value)"
                                    onkeyup="if(event.key === 'Enter') CurricularGamification.checkLlevadaUnits(this.value); else CurricularGamification.checkLlevadaUnits(this.value)">
                            </div>
                        </div>
                    </div>

                    <!-- RIGHT: ACTION PANEL -->
                    <div id="action-panel" style="display:flex; flex-direction:column; align-items:center; justify-content:center; width:220px; min-height:300px;">
                        <div id="llevada-msg" style="font-weight:bold; color:#7e22ce; font-size:1.2rem; text-align:center; margin-bottom:20px;">
                            Suma las Unidades<br>
                            <span style="font-size:0.9rem; color:#6b7280; font-weight:normal;">(Pulsa INTRO al terminar)</span>
                        </div>
                        <!-- Dynamic Buttons will appear here -->
                    </div>
                </div>
            </div >
    `;
    },

    checkLlevadaUnits(val) {
        // [FIX] More robust input parsing
        const inputVal = parseInt(val);
        if (isNaN(inputVal)) return;

        const units = this.activeGameData.totalU % 10;
        const total = this.activeGameData.totalU;

        // Check if user entered the correct unit OR the full sum
        const isCorrectUnit = inputVal === units;
        const isFullSum = inputVal === total && total >= 10;

        if (isCorrectUnit || isFullSum) {
            // If they typed 12, correct it to 2 visually
            if (isFullSum) {
                const inputEl = document.getElementById('ans-u');
                // [FIX] Update ghost input when auto-correcting
                if (inputEl) {
                    inputEl.value = units;
                    this.updateGhostInput(units);
                }
            }

            // Correct units
            const inputEl = document.getElementById('ans-u');
            if (inputEl) {
                inputEl.disabled = true;
                // Keep transparent background logic but change border
                inputEl.style.borderColor = "#10b981";
                // We keep text transparent, ghost handles color
            }

            // TARGET NEW ACTION PANEL
            const actionPanel = document.getElementById('action-panel');
            const msgEl = document.getElementById('llevada-msg');

            if (actionPanel) {
                if (msgEl) msgEl.innerText = "¡Bien! Ahora... ¡LANZA EL COHETE! 🚀";

                // Show Rocket Button to Carry
                if (!document.getElementById('rocket-carry-btn')) {
                    const btn = document.createElement('button');
                    btn.id = 'rocket-carry-btn';
                    btn.innerHTML = "LANZAR LLEVADA 🚀";
                    btn.className = "btn";
                    btn.style.cssText = "margin-top:20px; background:#dc2626; color:white; font-size:1.2rem; padding:15px 30px; border-radius:30px; cursor:pointer; animation:bounce 1s infinite; border:4px solid #fecaca; box-shadow:0 5px 15px rgba(220, 38, 38, 0.4);";
                    btn.onclick = () => {
                        btn.remove();
                        this.animateCarry();
                    };
                    actionPanel.appendChild(btn);
                    // Auto-focus button for Enter key support
                    btn.focus();
                }
            }

            this.safePlay('success');
        }
    },

    animateCarry() {
        CurricularGamification.safePlay('pop');
        const slot = document.getElementById('carry-slot');
        slot.innerText = "1";
        slot.style.background = "#fee2e2"; // Reddish bg
        slot.style.color = "#dc2626"; // Red text
        slot.classList.add('pop-in');

        document.getElementById('ans-d').disabled = false;
        document.getElementById('ans-d').style.borderColor = "#9333ea";
        document.getElementById('ans-d').focus();

        // ⬇️ Visual Cue for Carry
        const carryArrow = document.createElement('div');
        carryArrow.innerHTML = "⬇️ ¡Súmame!";
        // Red color for carry arrow
        carryArrow.style.cssText = "position:absolute; top:-30px; left:-60px; color:#dc2626; font-weight:bold; animation: bounce 1s infinite; white-space:nowrap;";
        slot.style.position = "relative";
        slot.appendChild(carryArrow);

        // Update message in Action Panel
        const msgEl = document.getElementById('llevada-msg');
        if (msgEl) {
            msgEl.innerHTML = "¡Ahora suma las Decenas!<br>" +
                `< div style = 'margin-top:10px; font-size:1.5rem; color:#dc2626; background:#fef2f2; padding:10px; border-radius:10px; border:1px solid #fecaca;' > ` +
                `${Math.floor(this.activeGameData.totalD / 10) || ''}${this.activeGameData.totalD % 10 - 1} + 1(llevada)</div > ` +
                `< div style = 'font-size:0.9rem; color:#6b7280; font-weight:normal; margin-top:10px;' > (Escribe el resultado y pulsa INTRO)</div > `;
        }

        document.getElementById('ans-d').onkeyup = (e) => {
            const val = parseInt(e.target.value);
            // Allow Enter key or auto-check if correct
            if (val === this.activeGameData.totalD) {
                e.target.style.background = "#86efac";
                e.target.disabled = true;
                CurricularGamification.safePlay('success');

                // Show final success message in Action Panel
                if (msgEl) {
                    msgEl.innerHTML = "<div style='font-size:2rem;'>🎉 ¡EXCELENTE! 🎉</div>";
                }
                setTimeout(() => this.winGame(10), 800);
            }
        };
    },


    // --- COMMON ---
    winGame(level) {
        // 1. Stop all interactions/timers
        this.activeIntervals.forEach(clearInterval);
        this.activeIntervals = [];

        // 2. Play Effects
        // 2. Play Effects
        this.safePlay('success');
        setTimeout(() => this.safeSpeak("¡Genial! Has completado la misión."), 500);

        try {
            if (window.confetti) {
                confetti({ zIndex: 100000, particleCount: 200, spread: 100 });
            }
        } catch (e) { console.warn("Confetti Error:", e); }

        // 3. GLOBAL WIN OVERLAY (Attached to Body)
        // Check if exists to avoid duplicates
        if (document.getElementById('globalWinOverlay')) return;

        const overlay = document.createElement('div');
        overlay.id = 'globalWinOverlay';
        overlay.style.cssText = `
            position: fixed; top: 0; left: 0; width: 100vw; height: 100vh;
            background: rgba(255, 255, 255, 0.95);
            display: flex; flex-direction: column; align-items: center; justify-content: center;
            z-index: 99999; animation: fadeIn 0.5s ease-out;
            backdrop-filter: blur(5px);
        `;

        overlay.innerHTML = `
    <div class="win-card" style="background: white; padding: 40px; border-radius: 20px; box-shadow: 0 20px 50px rgba(0, 0, 0, 0.2); text-align: center; border: 4px solid #f59e0b; max-width: 90%; animation: bounceIn 0.8s cubic-bezier(0.215, 0.610, 0.355, 1.000);">
                <style>
                    @keyframes bounceIn { 0% { transform: scale(0.3); opacity: 0; } 50% { transform: scale(1.05); } 70% { transform: scale(0.9); } 100% { transform: scale(1); opacity: 1; } }
                </style>
                <div style="font-size:6rem; margin-bottom:10px;">🎉</div>
                <h1 style="font-size:2.5rem; color:#d97706; margin:0; text-transform:uppercase;">¡Misión Cumplida!</h1>
                <p style="font-size:1.5rem; color:#4b5563; margin:20px 0;">¡Lo has hecho fantástico!</p>
                <div style="display:flex; gap:10px; justify-content:center; flex-wrap:wrap;">
                    <button style="margin: 10px; padding: 15px 30px; font-size: 1.2rem; border-radius: 50px; border: none; cursor: pointer; transition: transform 0.2s; font-weight: bold; color: white; box-shadow: 0 4px 0 rgba(0, 0, 0, 0.2); background:#64748b;" onclick="CurricularGamification.closeGlobalWin()">🚪 SALIR</button>
                    <button style="margin: 10px; padding: 15px 30px; font-size: 1.2rem; border-radius: 50px; border: none; cursor: pointer; transition: transform 0.2s; font-weight: bold; color: white; box-shadow: 0 4px 0 rgba(0, 0, 0, 0.2); background:#3b82f6;" onclick="CurricularGamification.replayGlobalWin(${level})">🔄 VOLVER A JUGAR</button>
                </div>
            </div >
    `;
        document.body.appendChild(overlay);
    },

    closeGlobalWin() {
        const overlay = document.getElementById('globalWinOverlay');
        if (overlay) overlay.remove();
        // Award medal logic
        const level = this.activeGameData?.level || 1; // Fallback
        this.awardMedal(level);
    },

    replayGlobalWin(level) {
        const overlay = document.getElementById('globalWinOverlay');
        if (overlay) overlay.remove();
        this.startMiniGame(level);
    },

    awardMedal(level) {
        const mission = this.missions.find(m => m.level === level);
        this.closeModal();

        if (mission && window.GamificationService) {
            const progress = window.GamificationService.getProgress();
            if (!progress.medals.includes(mission.medal)) {
                progress.medals.push(mission.medal);
                window.GamificationService.saveProgress();
                this.renderRewardTrack();
            }
        }
    },

    renderRewardTrack() {
        let track = document.getElementById('islandRewardTrack');
        if (!track) {
            const matraz = document.querySelector('.bubble-btn');
            if (matraz) {
                track = document.createElement('div');
                track.id = 'islandRewardTrack';
                // [FIX] Added basic styles
                track.style.cssText = "position:fixed; bottom:20px; left:100px; z-index:1100; display:flex; gap:10px; align-items:center; pointer-events:auto; background:transparent; border:none;";
                matraz.parentNode.insertBefore(track, matraz.nextSibling);
            }
        }

        if (track && window.GamificationService) {
            // [FIX] Default empty progress if null
            const progress = window.GamificationService.getProgress() || { level: 1, medals: [] };
            const unlockedLevel = progress.level || 1;
            const medals = progress.medals || [];

            track.innerHTML = '';
            this.missions.forEach(m => {
                // Show icon if level is unlocked
                if (m.level <= unlockedLevel || medals.includes(m.medal)) {
                    const hasMedal = medals.includes(m.medal);
                    const islandIcon = document.createElement('div');
                    islandIcon.className = `island - reward - icon ${hasMedal ? 'completed' : ''} `;
                    islandIcon.innerHTML = hasMedal ? m.icon : '🔒';
                    if (m.level <= unlockedLevel && !hasMedal) islandIcon.innerHTML = '⚠️';

                    islandIcon.title = `${m.island} `;
                    islandIcon.onclick = () => {
                        if (hasMedal) alert(`Ya tienes la ${m.medal} `);
                        else this.showIslandReward(m.level);
                    };

                    islandIcon.style.cssText = `
                        width: 50px; height: 50px; border-radius: 50%;
                        background: ${hasMedal ? 'gold' : '#fff'};
                        display: flex; align-items: center; justify-content: center;
                        font-size: 1.5rem; cursor: pointer; border: 3px solid ${hasMedal ? '#b45309' : '#ccc'};
                        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
                    `;
                    track.appendChild(islandIcon);
                }
            });
        }
    },

    debugUnlockAll() {
        console.log("🔓 Unlocking all islands for debugging...");
        const maxLevel = 10;

        // Update gamification service
        if (window.GamificationService) {
            const currentProgress = window.GamificationService.getProgress();
            currentProgress.level = maxLevel;
            currentProgress.xp = 1000;
            currentProgress.unlockedIslands = maxLevel;
            window.GamificationService.saveProgress(currentProgress);
        }

        // Update AdventureMap config
        if (window.AdventureMap) {
            window.AdventureMap.config.currentIsland = maxLevel;
            window.AdventureMap.config.unlockedIslands = maxLevel;
            window.AdventureMap.saveProgress();
            window.AdventureMap.init(); // Refresh map
        }

        console.log("✅ All islands unlocked! Refresh the page if map doesn't update immediately.");

        // Show a huge notification
        const toast = document.createElement('div');
        toast.style.cssText = "position:fixed; top:20px; right:20px; background:#10b981; color:white; padding:20px; border-radius:12px; z-index:9999; font-weight:bold; font-size:1.2rem; box-shadow:0 10px 25px rgba(0,0,0,0.3); animation: slideIn 0.5s ease-out;";
        toast.innerHTML = "🔓 <br>¡MODO DEBUG ACTIVADO!<br>Todas las islas desbloqueadas.";
        document.body.appendChild(toast);
        setTimeout(() => {
            toast.style.opacity = '0';
            setTimeout(() => toast.remove(), 500);
        }, 4000);
    }
};

// Global Alias for console use
window.unlockAllIslands = () => CurricularGamification.debugUnlockAll();

window.CurricularGamification = CurricularGamification;
// Auto-init handled by script load if desired, or manually call init
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => CurricularGamification.init());
} else {
    CurricularGamification.init();
}
